module.exports = __webpack_public_path__ + "static/media/ProfileMob.7d9ddbac.png";